import { sortBy } from 'lodash/fp';
import { Control } from 'react-hook-form';
import styled from 'styled-components';

import LabeledFormFieldInput from 'dashboard/components-lib/LabeledFormFieldInput';
import LoadingIndicator from 'dashboard/components-lib/LoadingIndicator';
import { Paragraph } from 'design-system/components/Text';
import { Elevation } from 'design-system/variables/effect';
import { FieldSchema } from 'lib/fields';

const LoaderContainer = styled.div`
  position: relative;
  width: auto;
  overflow: hidden;
  background-color: ${({ theme }) => theme.color.background.primary};
  border-radius: ${({ theme }) => theme.card.borderRadius};
  box-shadow:
    0 0 0 3px '#ffffff',
    ${Elevation.High};
`;

interface PrefillTabProps {
  fieldSchema: FieldSchema[] | undefined;
  nullFieldSchemaMessage?: string;
  isLoading: boolean;
  submitting: boolean;
  control: Control;
}

const CreateInquiryFieldsPrefill = ({
  fieldSchema,
  nullFieldSchemaMessage,
  isLoading,
  submitting,
  control,
}: PrefillTabProps) => {
  return (
    <>
      {isLoading ? (
        <LoaderContainer>
          <LoadingIndicator />
        </LoaderContainer>
      ) : (
        <>
          {!fieldSchema && (
            <>
              <Paragraph>
                {fieldSchema == null
                  ? nullFieldSchemaMessage || 'Prefill not supported.'
                  : 'No fields to prefill for this template.'}
              </Paragraph>
            </>
          )}
          {fieldSchema &&
            sortBy(
              (fieldSchema: FieldSchema) => fieldSchema.label ?? fieldSchema.key,
              fieldSchema.map((schema) => {
                return (
                  <LabeledFormFieldInput
                    key={schema.key}
                    fieldSchema={schema}
                    control={control}
                    disabled={submitting}
                  />
                );
              }),
            )}
        </>
      )}
    </>
  );
};

export default CreateInquiryFieldsPrefill;
